<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_923')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('scope.text_924')" :count="params.data.length" :action="params.action" />
      <dialog-table :data="params.data" :columns="columns" />
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_925')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.customer_level" :placeholder="$t('scope.text_926')">
            <a-select-option v-for="(value, key) in levels" :key="key" :value="key">
              {{value}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import consts from '@scope/constants/consts'

export default {
  name: 'SetCustomerLevelDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        customer_level: [
          'customer_level',
          {
            initialValue: '' + (this.params.data[0].customer_level) || '0',
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      columns: [
        {
          field: 'enterprise_name',
          title: this.$t('scope.text_318'),
          width: 200,
          slots: {
            default: ({ row }, h) => {
              const ret = [
                <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.enterprise_name || '-' }</side-page-trigger>,
              ]
              return ret
            },
          },
        },
        {
          field: 'name',
          title: this.$t('scope.text_322'),
        },
        {
          field: 'mobile',
          title: this.$t('scope.text_494'),
        },
      ],
    }
  },
  computed: {
    levels () {
      return consts.customerLevelMap
    },
  },
  methods: {
    doSet (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'customer-level',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const { customer_level } = await this.form.fc.validateFields()
        await this.doSet({
          customer_level: Number(customer_level),
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
